// console.log('loaded DEADSIMPLE Core');
// console.log('web development by Tinybox Software Development');
import { setupAgeModal } from './utils/ageModal';

document.addEventListener(
  'avm-show',
  () => {
    setupAgeModal();
  },
  { once: true }
);
